import { render, staticRenderFns } from "./gifBagStyle.vue?vue&type=template&id=b5e0d58c&scoped=true"
import script from "./gifBagStyle.vue?vue&type=script&lang=js"
export * from "./gifBagStyle.vue?vue&type=script&lang=js"
import style0 from "./gifBagStyle.vue?vue&type=style&index=0&id=b5e0d58c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e0d58c",
  null
  
)

export default component.exports